<template>
  <v-container
    fluid
    fill-height
    pa-0
    :class="[
      $route.name === 'HistoryEvent' ? $style.eventContainer : $style.root
    ]"
    :style="{
      overflow: 'auto',
      maxHeight: $route.name === 'HistoryEvent' ? '100%' : `${tableHeight}px`
    }"
  >
    <DuaMessageRevisionSelect v-if="$route.name === 'HistoryEvent'" />
    <v-row class="fill-height" no-gutters>
      <DuaMessageForm :key="created" />
    </v-row>
  </v-container>
</template>

<script>
import DuaMessageForm from './DuaMessageForm'
import DuaMessageRevisionSelect from './DuaMessageRevisionSelect'
import inputTableHeight from '@/mixins/inputTableHeight'
import { get } from 'vuex-pathify'

export default {
  name: 'DuaMessageContainer',

  components: { DuaMessageForm, DuaMessageRevisionSelect },

  mixins: [inputTableHeight(334)],

  computed: {
    event: get('event/selectedEvent'),
    created: get('duaMessage/model@created')
  }
}
</script>

<style lang="scss" module>
.root {
  height: calc(100vh - 334px);
}

.eventContainer {
  height: calc(100vh - 105px);
}
</style>
